import React from 'react';
import styles from './GridContainer.module.scss';
import cn from 'classnames';
import { gridContainerTypes } from '../../../../../../../HousingStock/components/ui/FlatsGrid/constants';
import { addressStagesColorsMap } from '../../../../../../../HousingStock/constants/stagesColorMaps';
import { getNumberUpToPoint } from '../../../../../../../HousingStock/components/ui/FlatsGrid/utils';
import FlatCell from '../FlatCell/FlatCell';
import { flatTypesColorsMap } from '../../../../../../../HousingStock/constants/typesColorMaps';

const rowPosition = (cells, gridType) => {
  const start = getNumberUpToPoint(cells[0].row);
  const end = getNumberUpToPoint(cells[cells.length - 1].row);

  if (gridType === gridContainerTypes.upper) {
    return `-${start + 1}/-${end + 2}`;
  }

  if (gridType === gridContainerTypes.basement) {
    return `${start + 1}/${end + 2}`;
  }

  if (gridType === gridContainerTypes.under) {
    return `${Math.abs(start)}/${Math.abs(end) + 1}`;
  }
};

const GridContainer = ({
  rowSize,
  numOfCol,
  colSize,
  flats,
  type = gridContainerTypes.upper,
  onFlatClick,
  activeFlat,
  title,
  onMouseOver,
  onMouseOut,
}) => {
  const getBgColor = (item) => {
    const stageId = item.addressLifeCycle?.stageAddressLifeCycle?.id;

    return stageId ? addressStagesColorsMap.get(stageId) : undefined;
  };

  return (
    <div
      className={styles.root}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        marginTop: type !== gridContainerTypes.upper ? '8px' : 0,
        gridAutoRows: `${rowSize}`,
        gridTemplateColumns: `repeat(${numOfCol}, minmax(${colSize}, 1fr))`,
      }}
    >
      {flats.map((flat) => {
        const cells = Array.isArray(flat) ? flat[0].cells : flat.cells;
        const row = rowPosition(
          cells.slice().sort((a, b) => a.row - b.row),
          type
        );
        const colCells = cells.slice().sort((a, b) => a.col - b.col);
        const colStart = getNumberUpToPoint(colCells[0].col);
        const colEnd =
          getNumberUpToPoint(colCells[colCells.length - 1].col) + 1;

        return (
          <div
            key={flat.flat}
            style={{
              gridRow: row,
              gridColumn: `${colStart}/${colEnd}`,
            }}
            className={styles.cell}
          >
            {Array.isArray(flat) &&
              flat.map((item) => (
                <FlatCell
                  key={item.flat}
                  flatData={item}
                  onClick={onFlatClick}
                  bgColor={getBgColor(item)}
                  borderColor={
                    item.address
                      ? flatTypesColorsMap.get(item.address.typeId)
                      : undefined
                  }
                  activeFlat={activeFlat}
                />
              ))}
            {!Array.isArray(flat) && (
              <FlatCell
                flatData={flat}
                onClick={onFlatClick}
                bgColor={getBgColor(flat)}
                borderColor={
                  flat.address
                    ? flatTypesColorsMap.get(flat.address.typeId)
                    : undefined
                }
                activeFlat={activeFlat}
              />
            )}
          </div>
        );
      })}
      {title && (
        <h4 className={cn(styles.title, styles.allColumns)}>
          <span>{title}</span>
        </h4>
      )}
    </div>
  );
};

export default GridContainer;
